import { categories, type CategorySlug } from '../config/brand';

interface CategoryFilterProps {
  active: CategorySlug | 'all';
  onChange: (c: CategorySlug | 'all') => void;
  available?: ReadonlyArray<string>;
}

export default function CategoryFilter({ active, onChange, available }: CategoryFilterProps) {
  const visible = available
    ? categories.filter((c) => available.includes(c.slug))
    : categories;
  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onChange('all')}
        className={`rounded-full px-4 py-1.5 text-sm font-medium ring-1 transition-all ${
          active === 'all'
            ? 'bg-brand-500 text-white shadow-sm ring-brand-500'
            : 'bg-white text-slate-700 ring-slate-200 hover:bg-slate-50 hover:ring-brand-200'
        }`}
      >
        All
      </button>
      {visible.map((c) => (
        <button
          key={c.slug}
          type="button"
          onClick={() => onChange(c.slug)}
          className={`rounded-full px-4 py-1.5 text-sm font-medium ring-1 transition-all ${
            active === c.slug
              ? 'bg-brand-500 text-white shadow-sm ring-brand-500'
              : 'bg-white text-slate-700 ring-slate-200 hover:bg-slate-50 hover:ring-brand-200'
          }`}
        >
          {c.name}
        </button>
      ))}
    </div>
  );
}
